import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DeleteItemChart, GetGraphByUserId } from '../../../reduxToolkit/Graphs/GraphsApi';
import CustomModal from '../../../components/Modal/CustomModal';
import { CustomSelect } from './../../../components/CustomSelect';
import { toast } from 'react-toastify';
import i18n from 'i18next';
import CustomDescriptionModal from '../../../components/CustomDescriptionModal';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeleteDashboardModal = ({ show, onHide, userId }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [dashboardId, setDashboardId] = useState('');
    const { t } = useTranslation();
    // Get current graph data from Redux store
    const graphData = useSelector((state) => state.GraphsSlice.getGraphByUserId);
    /**
     * Handles the deletion of a dashboard.
     * Sends a request to delete the selected dashboard by ID,
     * then refreshes the graph data and closes the modal.
     */
    const handleDelete = () => {
        const table = 'dashboard';
        const body = [dashboardId];
        setLoading(true);

        dispatch(DeleteItemChart({ table, body })).then(
            ({
                payload: {
                    data: { success },
                },
            }) => {
                if (success) {
                    dispatch(GetGraphByUserId(userId)).then(() => {
                        setLoading(false);
                        toast.success(t('has_been_deleted_successfully'));
                        onHide();
                    });
                } else {
                    setLoading(false);
                }
            },
        );
    };

    return (
        <CustomModal
            title='delete'
            size='lg'
            onHide={onHide}
            onConfirm={handleDelete}
            buttonConfirm='confirm'
            buttonCancelText='cancel'
            cancelButton
            confirmButton
            closeButton
            show={show}
            confirmDisabled={!dashboardId}
        >
            <h5 className='label-graph-top'>{t('select_dashboard')}</h5>
            <CustomSelect
                id='slt_agm_dashboard'
                value={dashboardId || ''}
                onChange={(e) => setDashboardId(e.target.value)}
                className='form-select form-select-sm mb-3'
                trans='select_dashboard'
                list={Array.isArray(graphData) ? graphData : []}
                keyName='id'
                required
                showNoSelectionOption={true}
            >
                {graphData.map((dashboard) => (
                    <option key={dashboard.id} value={dashboard.id}>
                        {dashboard.name.toUpperCase()}
                    </option>
                ))}
            </CustomSelect>

            <CustomDescriptionModal>
                {t('are_you_sure_you_want_to_delete')}
            </CustomDescriptionModal>
        </CustomModal>
    );
};

export default DeleteDashboardModal;
